<template>
  <!-- 发票管理 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="modifyClick({}, 1)"
          >新增</el-button
        >
        <el-button class="glo_btnItems" @click="InvoicesComfirms"
          >开票确认</el-button
        >
        <el-button class="glo_btnItems" @click="UnComfirms"
          >批量取消确认</el-button
        >
        <el-button class="glo_btnItems" @click="deleteClick"
          >批量删除</el-button
        >
        <el-button class="glo_btnItems" @click="Sentbymail">邮寄发出</el-button>
        <el-button class="glo_btnItems" @click="modifyClick({}, 2)"
          >复制发票</el-button
        >
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>

        <el-table-column fixed="right" label="操作" min-width="220px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="modifyClick(scope.row, 3)"
                >修改</el-button
              >
              <el-button class="rbtns" @click.stop="deleteClick(scope.row)"
                >删除</el-button
              >
              <el-button class="rbtns" @click.stop="UnComfirms(scope.row)"
                >取消确认</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>
    <!-- 邮寄发出 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      :isAppend="true"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn"
    >
      <div class="formbox" v-if="isShowDialog">
        <el-form class="glo_formBox" label-width="120px">
          <el-form-item class="dialogTims" label="发出日期:">
            <el-date-picker
              class="input"
              v-model="dialogForm.sendDate"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="dialogTims" label="寄出人:">
            <el-input
              v-model="dialogForm.sender"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="dialogTims" label="邮寄单号:">
            <el-input
              v-model="dialogForm.sendOrderNumber"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item class="textArea" label="邮寄备注:" style="width: 100%">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>
  </div>
</template>
<script>
import tableList from "@/pages/tableList.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import { mixin_print } from "@/assets/js/Mixins/mixinPrint";
import myDialog from "@/components/Dialog.vue";

import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
export default {
  mixins: [tableList, mixin_print, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "发票管理", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "FinancialManagement_InvoicesControlRX", //  页面标识
      reportFiledsNumber: "admin_invoice_list", // 动态 条件、表头
      isShowDialog: false,
      dialogTitle: "邮寄发出",
      diaWidth: "520px",
      dialogForm: {
        financeInvoiceIds: [],
        remarks: "",
        sendDate: "",
        sendOrderNumber: "",
        sender: "",
      },
    };
  },
  mounted() {},
  watch: {},
  methods: {
    // 修改
    modifyClick({ invoiceId = "" }, keyType) {
      // keyType 1 新增  2 复制   3 修改  4 开票确认
      if (keyType == 2) {
        if (this.selectTableData.length != 1) {
          this.$message.error("请选择一条数据进行操作");
          return false;
        } else {
          invoiceId = this.selectTableData[0].invoiceId;
        }
      }

      this.$router.push({
        path: "/FM/InvoicesControlRX/InvoicesAddRX",
        query: {
          invoiceId,
          keyType,
        },
      });
    },
    //邮寄发出
    Sentbymail() {
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.dialogForm.financeInvoiceIds = this.selectTableData.map((n) => {
          return n.invoiceId;
        });
        this.isShowDialog = true;
      }
    },
    // 删除
    deleteClick(row) {
      const that = this;
      if (row.invoiceId) this.selectTableData = [row];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let cancelReq = {
              invoiceIds: new Array(),
            };
            that.selectTableData.map(function (val, i) {
              cancelReq.invoiceIds.push(val.invoiceId);
            });
            that.$API.invoiceadelInvoice(cancelReq).then((res) => {
              if (res.data.status === "success") {
                that.$message.success(res.data.message);
                that.getData();
              }
            });
          })
          .catch((err) => {
            if (invoiceId) this.selectTableData.length = 0;
          });
      }
    },
    // 开票确认
    InvoicesComfirms() {
      if (this.selectTableData.length != 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        this.$router.push({
          path: "/FM/InvoicesControlRX/InvoicesAddRX",
          query: {
            invoiceId: this.selectTableData[0].invoiceId,
            keyType: 4,
          },
        });
      }
    },
    // 取消确认
    UnComfirms(row) {
      const that = this;
      if (row.invoiceId) this.selectTableData = [row];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确认要把所选数据 取消开票确认？", "提示:")
          .then((res) => {
            let cancelReq = {
              invoiceIds: new Array(),
            };
            that.selectTableData.map(function (val, i) {
              cancelReq.invoiceIds.push(val.invoiceId);
            });
            that.$API.invoicecancelInvoiceSure(cancelReq).then((res) => {
              if (res.data.status === "success") {
                that.$message.success(res.data.message);
                that.getData();
              }
            });
          })
          .catch((err) => {
            if (invoiceId) this.selectTableData.length = 0;
          });
      }
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
      this.dialogForm = {
        financeInvoiceIds: [],
        remarks: "",
        sendDate: "",
        sendOrderNumber: "",
        sender: "",
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$API.invoicesendInvoice(this.dialogForm).then((res) => {
        this.$message.success(res.data.message || "操作成功");
        this.getData();
        this.isShowDialog = false;
      });
    },
  },
};
</script>
<style scoped lang="less">
.textArea {
  height: auto !important;
}
</style>